import { Flex, Text, Button, toast } from "@jsq/ds/core";
import { client } from "~/apollo/client";
import { useAssignCaseMutation } from "~/graphql/supergraphHooks";
import { SPACING } from "~/styles/variables";

interface Props {
  caseId: number;
}

const AssignControls = ({ caseId }: Props) => {
  const [assignCase, { loading }] = useAssignCaseMutation({
    refetchQueries: ["GetComplianceCase", "GetComplianceCaseAuditLogs"],
    onCompleted: async () => {
      toast.success("Case assigned successfully");
      await client.refetchQueries({
        include: "active",
      });
    },
    onError: (e) => toast.error(e.message),
  });

  return (
    <Flex
      style={{ margin: `${SPACING.X_SMALL} ${SPACING.LARGE}` }}
      justifyContent="space-between"
    >
      <Text variant="secondary-md" style={{ margin: `${SPACING.X_SMALL}` }}>
        <>
          Unassigned{" "}
          <Button
            css={{ margin: `${SPACING.X_SMALL} ${SPACING.SMALL}` }}
            isInline
            variant="neutral"
            disabled={loading}
            onClick={() => void assignCase({ variables: { caseId: caseId } })}
          >
            Assign to myself
          </Button>
        </>
      </Text>
    </Flex>
  );
};

export default AssignControls;
